import { PatientOrder, PatientOrderControllerApi } from "../services";
import { getConfigObject, useMutationWithLoading } from "../utils/utils";

/**
 * @author Shrinivas Mandhare
 */
export const useAddLabRequisition = () =>
  useMutationWithLoading(
    async (params: { patientOrder: PatientOrder; xTENANTID?: string }) =>
      new PatientOrderControllerApi(getConfigObject()).createPatientOrder(
        params.patientOrder,
        params.xTENANTID
      )
  );
